import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {//state inizializzato coi valori di default
    id: null,
    nome: null,
    email: null,
    tel: null,
    password: null,
    ruolo: null,
    azienda: null, 
    puntoVendita: null,
    cco: null,
    active: null,
    loading: false,
    error: false,
    isFulFilled: false
} 

export const serializeAndStringify = obj => {
    //questa funzione è necessaria sennò axios impazzisce appena legge gli oggetti che gli passi
    const seen = []
    JSON.stringify(
        obj,
        (_, val) => {
            if(val != null && typeof val === 'object') {
                if(seen.indexOf(val) >= 0)
                    return
                seen.push(val)
            }
            return val                
        }
    )
    return seen[0]
}

export const fetchUserData = createAsyncThunk(
    'userAuth', 
    async ({ requestUrl, userData }) => {
        const resp = await axios.post(requestUrl, serializeAndStringify(userData))
        return resp.data
    }
)

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setLoading (state, { payload }) {
            state.loading = payload
            state.error = false
        },
        setError (state, { payload }) {
            state.error = payload
        },
        logOut (state) {
            state.id = null
            state.nome = null
            state.email = null
            state.tel = null
            state.password = null
            state.ruolo = null
            state.azienda = null
            state.puntoVendita = null
            state.cco = null
            state.active = null
            state.loading = false
            state.error = false
            state.isFulFilled = false
        },
        setIsFulFilled (state, { payload }) {
            state.isFulFilled = payload
        }
    },
    extraReducers: {
        [fetchUserData.pending]: state => {//in attesa
            state.loading = true
        },
        [fetchUserData.fulfilled]: (state, { payload }) => {//registrazione completata 
            state.loading = false
            state.error = false
            state.isFulFilled = true
            state.id = payload._id
            state.nome = payload.nome
            state.email = payload.email
            state.tel = payload.tel
            state.password = payload.password  
            state.ruolo = payload.ruolo
            state.azienda = payload.azienda
            state.puntoVendita = payload.puntoVendita
            state.cco = payload.cco
            state.active = payload.active
        },
        [fetchUserData.rejected]: (state, { error }) => {//errore
            state.loading = false
            state.error = error.message
        }
    }
})

export const { logOut, setLoading, setError, setIsFulFilled } = userSlice.actions
export default userSlice.reducer